const STORE_KEY = 'BOTS'

export const FETCH_BOTS = `${STORE_KEY}/FETCH_BOTS`
